import React from "react";


// HOME DA PÁGINA ANÚNCIOS
export const AnunciosIndex = props => {
    return (
        <>
            <div className="anuncios">
                ANÚNCIOS
            </div>
        </>
    );
}


export default AnunciosIndex;